export interface CountyData {
  id: string;
  name: string;
  description: string;
}

export const initialCountyData: CountyData = {
  id: "",
  name: "",
  description: "",
};
